import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import withStyles from 'isomorphic-style-loader/withStyles';
import axios from 'axios';

import Link from '../../Link';
import ImageUploadComponent from '../../../components/Common/ImageUploadComponent';
import CommonImageDisplay from '../CommonImageDisplay/CommonImageDisplay';
import Loader from '../../Common/Loader/Loader';
import SelectFieldComponent from '../../Common/SelectFieldComponent/SelectFieldComponent';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';

import submit from './submit';
import messages from '../../../locale/messages';
import validate from './validate';
import { updateTempImages } from '../../../actions/siteadmin/TempImages/updateTempImages';
import { api, staticpageUploadDir } from '../../../config';
import { formatLocale } from '../../../helpers/formatLocale';
import { demoRestriction } from '../../../actions/demoRestriction';
import { AddContentPlusIcon, DeleteContentPlusIcon } from '../../Common/Assets/SVGIcon/CommonSvgRemainingIcon';

import bt from '../../../components/commonStyle.css';
import s from './StaticPageEditForm.css';

export class StaticPageEditForm extends Component {
	constructor(props) {
		super(props)
		if (typeof window !== 'undefined') {
			this.CustomEditor = require('../../Common/Editor/CustomEditor');
		}
		this.state = {
			editorHtml: '',
			selectedLanguages: []
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicStaticContent } = nextProps;
		let filteredLanguages = dynamicStaticContent?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	success = async (file, fromServer) => {
		const { change, updateTempImages, demoRestriction } = this.props;
		const isRestrict = await demoRestriction({});
		if (isRestrict) return;
		await change('pageBanner', fromServer && fromServer.fileName);
		await updateTempImages('StaticPage', 'staticPage', fromServer && fromServer.fileName);
	}


	renderQuill = ({ input, label, type, meta: { touched, error }, className }) => {
		const { Editor } = this.CustomEditor;
		const { formatMessage } = this.props.intl;

		return (
			<div>
				<Editor {...input} />
				{touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
			</div>
		);
	}

	async imageHandler() {
		const input = document.createElement('input');
		input.setAttribute('type', 'file');
		input.setAttribute('accept', 'image/*');
		input.click();
		input.onchange = async () => {
			const file = input.files[0];
			const formData = new FormData();

			formData.append('image', file);

			// Save current cursor state
			const range = this.quill.getSelection(true);

			// Move cursor to right side of image (easier to continue typing)
			this.quill.setSelection(range.index + 1);

			// Get the filePath from Uploaded URL
			const response = await axios.post('/file-upload-cms', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			});

			// Get Response from the String
			const data = await response?.data;
			let filePath = data.filePath;

			// Remove placeholder image
			this.quill.deleteText(range.index, 1);
			filePath = "/" + filePath;

			// Insert uploaded image
			const { ops } = this.quill.insertEmbed(range.index, 'image', filePath);

		};
	}

	renderFieldArray = ({ fields, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		const { languageList } = this.props;
		const { selectedLanguages } = this.state;

		return (
			<div className={bt.languageBox}>
				{fields && fields.map((item, index) => {
					let fieldLength = fields.length - 1;
					const currentLanguage = fields?.get(index)?.language;
					const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);
					const languagesOption = [{ value: '', label: formatMessage(messages.chooseLanguageLabel) }];
					const languageOptionsFormatted = availableLanguages.map((locale) => {
						return {
							value: locale,
							label: formatLocale(locale)
						};
					});
					languagesOption.push(...languageOptionsFormatted);
					return (
						<div key={index}>
							<div className='oneColumnGrid'>
								<div className='twoColumnGrid'>
									<Field
										name={`${item}.language`}
										component={SelectFieldComponent}
										label={formatMessage(messages.language)}
										options={languagesOption}
										inputClass={bt.formControlSelect}
									/>
								</div>

								<div className='quillBox'>
									<label className={bt.commonLabelText} ><FormattedMessage {...messages.content} /></label>
									<Field
										name={`${item}.content`}
										type="text"
										component={this.renderQuill}
										autoComplete={false} />
								</div>
							</div>
							<div className={cx(bt.languageBtnContainer, 'svgImg', { [bt.languageBtnContainerOne]: (fieldLength > 0) })}>
								{(fields.length <= languageList?.length - 1) && fieldLength == index &&
									<Button onClick={() => fields.length <= languageList?.length - 1 && fields.push({})} className={cx(bt.languageBtn)}>
										<AddContentPlusIcon />
										<span>{formatMessage(messages.addLanguage)}</span>
									</Button>
								}

								{fieldLength > 0 && <div>
									<Button onClick={() => fields.remove(index)} className={cx(bt.languageBtn, bt.languageDeleteBtn)}>
										<DeleteContentPlusIcon />
										<span>{formatMessage(messages.deleteLanguage)}</span>
									</Button>
								</div>}
							</div>
						</div>
					)
				})}
			</div >
		)
	}

	render() {
		const { error, handleSubmit, pageBanner, staticContentLoader, loading, submitting } = this.props;
		const { formatMessage } = this.props.intl;
		if (typeof window !== 'undefined') {
			return (
				<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
					<h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.editPageDetails)}</h1>
					<div className={cx(bt.space4, s.singleCard)}>
						<div className={cx(s.profileImgSection, s.profileImgWidth)}>
							<label className={bt.commonLabelText} >{formatMessage(messages.pageBanner)}</label>
							<CommonImageDisplay loader={staticContentLoader} imageSrc={pageBanner ? api?.apiEndpoint + staticpageUploadDir + 'large_' + pageBanner : null} />
							<ImageUploadComponent
								className='commonSiteAdminDropzoneSpace'
								subText={formatMessage(messages.maximumUploadSizeLabel)}
								defaultMessage={formatMessage(messages.chooseFile)}
								componentConfig={{
									iconFiletypes: ['.jpg', '.png', '.svg'],
									multiple: false,
									showFiletypeIcon: false,
									postUrl: api.apiEndpoint + '/uploadStaticBannerImage'
								}}
								success={this.success}
								loaderName={'staticContentLoader'}
							/>
						</div>
					</div>
					<div className='twoColumnGrid'>
						<Field
							name="metaTitle"
							type="text"
							placeholder={formatMessage(messages.metaTitle)}
							component={InputFieldComponent}
							label={formatMessage(messages.metaTitle)}
							inputClass={bt.formControlInput}
						/>

						<Field
							name="metaDescription"
							type="text"
							placeholder={formatMessage(messages.metaDescriptionText)}
							component={InputFieldComponent}
							componentClass="textarea"
							label={formatMessage(messages.metaDescriptionText)}
							inputClass={bt.formTextArea}
							onChange={(event) => { }}
						/>
					</div>

					<div className={bt.sectionDividerBorder} />
					<FieldArray
						name='content'
						rerenderOnEveryChange={true}
						component={this.renderFieldArray} />


					<div className={cx(bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider)}>
						<Form.Group className={s.formGroup}>
							<div className='doubleBtnFlexEnd'>
								<Link to={'/siteadmin/staticpage/manage'} className={bt.btnSecondary} >{formatMessage(messages.goBack)}</Link>
								<Loader
									type={"button"}
									label={formatMessage(messages.submitButton)}
									show={loading}
									buttonType={'submit'}
									className={cx(bt.btnPrimary, 'loaderButtonFlex')}
									disabled={submitting || loading}
								/>
							</div>
						</Form.Group>
					</div>
				</Form>
			)
		} else {
			return <div></div>
		}
	}
}
StaticPageEditForm = reduxForm({
	form: 'StaticPageEditForm',
	onSubmit: submit,
	validate
})(StaticPageEditForm);
const selector = formValueSelector('StaticPageEditForm')
const mapState = (state) => ({
	pageBanner: selector(state, 'pageBanner'),
	staticContentLoader: state?.loader?.staticContentLoader,
	languageList: state?.runtime?.availableLocales,
	dynamicStaticContent: selector(state, 'content'),
	loading: state.loader.StaticPageEditForm,
})
const mapDispatch = {
	updateTempImages,
	change,
	demoRestriction
}
export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(StaticPageEditForm)));
